window.ItemPromo = {
	
	/**
	 * @desc init computing input, qtip, tabs
	 * @returns {undefined}
	 */
	init: function() {
		
		$('input.discountamount').change(function () {
			ItemPromo.computePromoPrices();
		});
		
		$('select.discountunit').change(function () {
			
			ItemPromo.onDiscountWithHardPrices($(this));
			
			if($(this).val() != 'price'){
				ItemPromo.computePromoPrices();
			}
		});

		$('.rateCategories4Promo input.price').change(function () {
            ItemPromo.formatPrice(this);
        });
		
		MyTabs.initHorizontal('promotionDetails_new');
		Qtip.init();
		ItemPromo.initMultiple();
		ItemPromo.onDiscountWithHardPrices($('select.discountunit'));
		ItemPromo.computePromoPrices();
		ItemPromo.formatAllPrices();
	},

	/**
     * 
     * @returns {undefined}
     */
    formatAllPrices: function(){
        $('.rateCategories4Promo input.price').each(function () {
            ItemPromo.formatPrice(this);
        });
    },

	/**
     *
     * @param {HTMLElement} element
     * @returns {undefined}
     */
	formatPrice: function(element) {
		var numberFormat = NumberFormat.loadFromInputs("numformat_");
		var precisionCustomCurrent = $(element).attr('e_formatnum_precisioncustom');
		$(element).val(NumberFormat.formatToDisplay($(element).val(), numberFormat, undefined, precisionCustomCurrent));
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	initMultiple: function(){
		
		$('.linked').multipleSelect({
			selectAll	: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
		});
		
	},
	
	/**
	 * 
	 * @param {type} promotionid
	 * @param {type} state
	 * @returns {undefined}
	 */
	overview: function(promotionid, state, type, canEdit){
		
		promotionid = undefined === promotionid ? "" : promotionid;
		state       = undefined === state       ? "" : state;
		canEdit     = undefined === canEdit     ? false : canEdit;
		
		title = Loc.g('Visualisation de la promotion');
		
		var options = {
			
			title	: title,
			width	: 970,
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click :  function(){
						$(this).dialog("close");
					}
				}
			],
			callback : function(){
				MyTabs.initHorizontal('promoOverview-details');
				MyFacture.loadPromoQtip();
				var request = {
					action: 'getLinkedDocs', 
					'promotionid' : promotionid
				};
				
				MyFacture.post('cataloguepromo', request, function (data) {
					$('.DocLinkedElementsListContainer').find('.DocLinkedElementsList-content').html(data);
				}, 'html');
				
			}
		};

		if (canEdit) {
			options.buttons.push({
				text : Loc.g("Modifier"),
				click : function(){
					ItemPromo.updatePromo(promotionid, state, type);
				}
			});
		}

		MyWindow.load("cataloguepromo", {action:"overview", promotionid : promotionid}, options);
		
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	addPromoOnChild : function(){
		MyWindow.alert(Loc.g("Pour créer une promotion, rendez vous sur une fiche déclinaison."), {type:'warning'});
	},
	
	/**
	 * 
	 * @param {type} type
	 * @param {type} id
	 * @param {type} declid
	 * @param {type} context
	 * @returns {undefined}
	 */
	addPromo: function(type, id, declid, context){
		
		id		= undefined==id	? "" : id;
		declid	= undefined==declid || ""==declid 	? "0"	: declid;
		context	= undefined==context  ? "item_promo" : context;
		
		var title = Loc.g('Ajouter une promotion catalogue');
		
		if(context == 'coupon'){
			title = Loc.g('Ajouter un code promotionnel');
		}
		
		var formID = 'itemPromoForm';
		
		var options = {
			
			title	: title,
			width	: 870,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	:  function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer la promotion"),
					click	: function(){
						
						if(context == 'coupon' && $('#itemPromoForm select[name="promo_useOnPos"]').val() == 'Y' && $('#itemPromoForm select.discountunit').val() == 'amount'){
							MyWindow.alert(Loc.g("Les réductions en montant ne sont pas autorisées sur la caisse"));
							return false;	
						}

						$('#'+formID).submit();
					}
				}
			],
			callback : function(){

				var formId = "itemPromoForm";
				var options = {
					data	: {
						action: 'recordPromoForm'
					},
					success	:function(data){
						var formIsOk = MyForm.processJson(data, formID);
						if (formIsOk){
							Utils.reload();
						}
					}, 
					dataType:"json"
				};
			
				MyForm.prepare(formId, "cataloguepromo", options, true);
				
				$('#promo_name').focus();
				$("#promo_enddate").datepicker( "option" , 'minDate' , new Date());
				$("#promo_startdate").datepicker('setDate', new Date());
				
				ItemPromo.init();
				MyFacture.customForm('#'+formID);
			}

		};
		
		MyWindow.load("cataloguepromo", {action:"form", type:type, itemid:id, declid:declid, context:context}, options);
		
	},
	
	/**
	 * 
	 * @param {type} pid
	 * @param {type} state
	 * @param {type} mode
	 * @param {type} ihpid
	 * @returns {undefined}
	 */
	updatePromo : function(pid, state, mode, ihpid){
		
		pid			= undefined==pid	? ""	: pid;
		state		= undefined==state	? ""	: state;
		mode		= undefined==mode	? ""	: mode;
		ihpid		= undefined==ihpid	? ""	: ihpid;
		
		title = Loc.g('Modifier la promotion');
		
		var formID = 'itemPromoForm';
		
		var options = {
			title	: title,
			width	: 870,
			buttons	: [],
			callback : function(){

				var formId	= "itemPromoForm";
				var options = {
					data	: {
						action: 'recordPromoForm'
					},
					success	: function(data){
						var formIsOk = MyForm.processJson(data, formID);
						if (formIsOk){
							Utils.reload();
						}
					}, 
					dataType:"json"
				};

				MyForm.prepare(formId, "cataloguepromo", options, true);
				
				ItemPromo.init();
				MyFacture.customForm('#'+formID);
			}

		};
		
		options.buttons.unshift({
				text : Loc.g("Enregistrer les modifications"),
				'class' : 'btn btn-primary',
				click : function(){

					if(mode == 'coupon' && $('#itemPromoForm select[name="promo_useOnPos"]').val() == 'Y' && $('#itemPromoForm select.discountunit').val() == 'amount'){
						MyWindow.alert(Loc.g("Les réductions en montant ne sont pas autorisées sur la caisse"));
						return false;	
					}

					$('#'+formID).submit();
				}
		});
		
		if(state != 'waiting' && state != 'finished'){
			
			options.buttons.unshift({
				text	: (state == 'inprogress') ? Loc.g("Mettre en Pause") : Loc.g("Reprendre"),
				'class' : 'btn btn-primary',
				click : function(){
					if(state == 'inprogress'){
						ItemPromo.stopPromo(pid);
					} else {
						ItemPromo.playPromo(pid);
					}
				}
			});
			
		}
		
		if(state != 'finished'){
			
			options.buttons.unshift({
				text : Loc.g("Terminer"),
				'class' : 'btn btn-primary',
				click :  function(){
					ItemPromo.finishPromo(pid);
				}
			});
			
		}
		
		options.buttons.unshift({
			text	: Loc.g("Annuler"),
			'class' : 'btn btn-default',
			click	:  function(){
				$(this).dialog("close");
			}
		});
		
		MyWindow.load("cataloguepromo", {action:"form", promotionid : pid, item_promotionid : ihpid,context : mode}, options);
	},
	
	/**
	 * 
	 * @param {type} ihpid
	 * @returns {undefined}
	 */
	updatePrices : function(ihpid){
		
		ihpid = undefined==ihpid ? "" : ihpid;
		
		title = Loc.g('Modifier les tarifs');
		
		var formID = 'itemPromoForm';
		
		var options = {
			
			title	: title,
			width	: 870,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					class : 'btn-default',
					click	:  function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
                    class : 'btn-primary',
					click	: function(){
						$('#'+formID).submit();
					}
				}
			],
			callback : function(){

				var formId = "itemPromoForm";
				
				var options = {
					data	:{
						action: 'recordPromoForm'
					},
					success	: function(data){
						
						var formIsOk = MyForm.processJson(data, formID);
						
						if (formIsOk){	
							Utils.reload();
						}
					}, 
					dataType:"json"
				};
			
				MyForm.prepare(formId, "cataloguepromo", options, true);
				ItemPromo.init();
				
				MyFacture.customForm('#'+formID);
			}

		};
		
		MyWindow.load("cataloguepromo", {action:"form", item_promotionid : ihpid, context:'updatePrices'}, options);		
	},

	/**
	 * 
	 * @param {type} id
	 * @returns {undefined}
	 */
	deletePromo : function(id){
		
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		: [
			{
				text : Loc.g("Annuler"), 
				click : function(){
					$(this).dialog("close");
					return false;
				}
			},
			{
				text : Loc.g("Valider"), 
				click : function(){
					
					MyWindow.wait('alertWindow');

					var optionsDlete = {
						action	: "deletePromo",
						promotionid	: id
					};

					MyFacture.post('cataloguepromo', optionsDlete, function (data) {
						Utils.reload();
					}, 'json');

				}
			}
		]
		};

		MyWindow.alert(Loc.g("Vous allez supprimer cette promotion ainsi que tous ses produits liés"), options);		
	},
	
	/**
	 * 
	 * @param {type} target
	 * @returns {undefined}
	 */
	showLinked: function(target){
		$( target ).slideToggle();
	},
	
	/**
	 * 
	 * @param {type} rcid
	 * @returns {undefined}
	 */
	autoCheck: function(rcid){
 		$('#promo_rateEnabled_' + rcid).prop('checked', true);
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	linkToExistingPromo: function(e){
		
		var v_elem = $(e.currentTarget);
		
		if($(v_elem).val() == 'new'){
			
			$(v_elem).closest('form').find('.promotionid-tokeninput').hide('fast');
			$(v_elem).closest('form').find('#promotionDetails_new').show('fast');
			$(v_elem).closest('form').find('#promotionDetails_existing').hide('fast');
			
		} else {
			$(v_elem).closest('form').find('.promotionid-tokeninput').show('fast');
			$(v_elem).closest('form').find('#promotionDetails_new').hide('fast');
			$(v_elem).closest('form').find('#promotionDetails_existing').show('fast');
		}
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	computePromoPrices: function() {
		
		var rc_prices		= $('.rateCategories4Promo').find('.price');
		var numberFormat	= NumberFormat.loadFromInputs("numformat_");
		var discountAmount	= $('input.discountamount').val() == '' ? 0 : $('input.discountamount').val();
		var discountType	= $('select.discountunit').val();
		
		// Discount amount formatting
		var precisionCustom = discountType != 'percent' ? 'unitAmount': undefined;
		$('input.discountamount').val(
			NumberFormat.formatToDisplay(discountAmount, numberFormat, undefined, precisionCustom)
		);
		discountAmount = $('input.discountamount').val() == '' ? 0 : $('input.discountamount').val();

		// it's possible that this node is not in dom
		if(rc_prices.length > 0) {
			
			rc_prices.each(function( index, value ) {
				var precisionCustom = $(this).attr('e_formatnum_precisioncustom');
				var precisionToApply = NumberFormat.getPrecisionToApply(numberFormat, precisionCustom);

				var rcPrice				= Big(parseFloat($( this ).attr('data-originalamount'), 10));
				var disAmntb4compute	= Big(NumberFormat.formatToFloat(discountAmount, numberFormat, undefined, precisionCustom));

				switch(discountType) {
					case 'percent':
						var temp1 = Big(100).minus(disAmntb4compute).div(100);
						var newPrice = Big(rcPrice * temp1).round(parseInt(precisionToApply, 10));
						break;
					case 'amount':
						var newPrice = rcPrice.minus(disAmntb4compute).round(parseInt(precisionToApply, 10));	
						break;
				}

				if(newPrice !== undefined){
					$(this).val(NumberFormat.formatToDisplay(newPrice, numberFormat, undefined, precisionCustom)); 
				}

			});
			
		}
		
	},
	
	/**
	 * 
	 * @param {type} select
	 * @returns {undefined}
	 */
	onDiscountWithHardPrices: function(select){
		
		var rc_prices		= $('.rateCategories4Promo').find('.price');
		var discountamount	= $('.onePromoToAdd input.discountamount');

		if(select.val() == 'price' ){
			
			$('.onePromoToAdd .formline-discountamount').addClass('hidden');
			
			discountamount.attr('readonly', true);
			discountamount.val('');
			discountamount.addClass('input_readonly');
			
			rc_prices.each(function() {
				$(this).prop('readonly', false);
			});
			
		} else {
			
			$('.onePromoToAdd .formline-discountamount').removeClass('hidden');
			discountamount.attr('readonly', false);
			discountamount.removeClass('input_readonly');
			
			rc_prices.each(function() {
				$(this).prop('readonly', true);
			});
						
		}	
		
		if(select.val() == 'percent'){
			
			if(discountamount.closest('.form-input').find('.input-addon').length == 0){
				discountamount.closest('.form-input').append('<span class="input-addon append"> % </span>');
			}
			
		} else {
			discountamount.closest('.form-input').find('.input-addon').remove();
		}
	
	},
	
	/**
	 * 
	 * @param {type} jqSelect
	 * @returns {undefined}
	 */
	onMassDiscountWithHardPrices: function(jqSelect){
		
		var select			= jqSelect;
		var line			= select.closest('.onePromoToAdd');
		var discountamount	= select.closest('.col').find('.massAdd_discountamount');
		
		if(select.val() == 'percent' || select.val() == 'amount'){
			
			discountamount.removeClass('input_readonly');
			line.find('.massAdd_discountPrice').each(function( index ) {
				$( this ).addClass('input_readonly');
			});			
			
		} else {
			
			discountamount.val('');
			discountamount.addClass('input_readonly');
			
			line.find('.massAdd_discountPrice').each(function( index ) {
				$( this ).removeClass('input_readonly');
			});			
			
		}
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	onNeverExpires: function(e){
		
		var e = $(e.currentTarget);
		
		var endateField = $(e).closest('.onePromoToAdd').find('.promo_enddate, .promo_endhour, .massAdd_enddate, .massAdd_endhour');
		if( $(e).is(':checked') ){
			
			endateField.val('');
			endateField.prop('readonly', true);
			endateField.css('pointer-events', 'none');
			
		} else {
			
			endateField.prop('readonly', false);
			endateField.css('pointer-events', 'all');
			
		}
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	itemListingFilter : function(e){
		
		var v_elem		= $(e.currentTarget);
		var promoName	= v_elem.closest('.filter_underlabel').find('.promotionname-listing');
		
		v_elem.val() == 'Y' ? promoName.show() : promoName.hide();
		
	},
	
	/**
	 * 
	 * @param {type} action
	 * @param {type} formId
	 * @returns {undefined}
	 */
	prepareMassAddingForm: function(action, formId){
		
		action = (action == undefined) ? 'recordMassAddPromotions' : action;
		formId = (formId == undefined) ? "massAddPromotions" : formId;
		
		MyFacture.customForm();
		
		var options = {
			data : {
				action	: action
			},
			
			success:function(data){
				var formIsOk = MyForm.processJson(data, formId);
				if(formIsOk){

					var options = {
						resizable	: false,
						noclose		: true,
						title		: Loc.g("Confirmation"),
						type		: "warning",
						buttons		: [
						{
							text : Loc.g("OK"), 
							click : function(){
								Utils.relocate('/?_f=cataloguepromo');
							}
						},
					]
					};
					MyWindow.close();
					MyWindow.alert(Loc.g("Les promotions ont été enregistrées !"), options);

				} else {

					$(".onePromoToAdd").each(function() {
						$(this).css('background-color', '#FFFFF');
					});

					if(data.form.fields){

						$(data.form.fields).each(function() {

							var res		= $( this )[0].fieldId.split("_");
							var itemid	= $(res).get(-2);
							var declid	= $(res).get(-1);

							$('#onePromoToAdd_'+ itemid + '_' + declid).css('background-color', '#FFD2D2');
						});

					}

				}
			}, 
			dataType:"json"
		};
		
		MyFacture.customForm('#'+formId);
		MyForm.prepare(formId, "cataloguepromo&", options, true);
		
		ItemPromo.MassComputePrices();
		
		var minDate = new Date();
		$("#massAdd_startdate, .massAdd_startdate").datepicker('setDate', minDate);
		$("#massAdd_endhour, .massAdd_endhour").val('');
		$("#massAdd_enddate, .massAdd_enddate").datepicker( "option", 'minDate', minDate);
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	MassComputePrices : function(){
		
		var numberFormat	= NumberFormat.loadFromInputs("numformat_");
		
		$('.massAdd_discountamount, .massAddDiscountUnit').change(function () {
			
			var line = $(this).closest('.onePromoToAdd');
			
			var discountUnit	= line.find('.massAddDiscountUnit').val();
			var discountAmount	= line.find('.massAdd_discountamount').val();
			var rateCategories	= line.find('.massAdd_discountPrice');
			
			
			rateCategories.each(function( index, value ) {
				
				var rcPrice				= Big(parseFloat($( this ).attr('data-originalamount'), 10));
				var disAmntb4compute	= Big(NumberFormat.formatToFloat(discountAmount, numberFormat));

				switch(discountUnit) {
					case 'percent':
						var temp1	 = Big(100).minus(disAmntb4compute).div(100);
						var newPrice = Big(rcPrice * temp1).round(2);	
						break;
					case 'amount':
						var newPrice = rcPrice.minus(disAmntb4compute).round(2);	
						break;
				}

				if(newPrice !== undefined){
					$(this).val(NumberFormat.formatToDisplay(newPrice, numberFormat));
				}

				$(this).removeClass('ui-state-error');
				$(this).trigger('change');

			});
			
		});
		
	},
	
	/**
	 * 
	 * @param {type} id
	 * @returns {undefined}
	 */
	stopPromo : function(id){
		
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
						return false;
					}
				},
				{
					text	: Loc.g("Oui"), 
					click	: function(){

						MyWindow.wait('alertWindow');

						var optionsDlete = {
							action	: "stopPromo",
							promotionid		: id
						};

						MyFacture.post('cataloguepromo', optionsDlete, function (data) {
							Utils.reload();
						}, 'json');

					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous mettre en pause cette promotion ?"), options);		
		
	},
	
	/**
	 * 
	 * @param {type} id
	 * @returns {undefined}
	 */
	finishPromo : function(id){
		
		var options = {
				resizable	: false,
				noclose		: true,
				title		: Loc.g("Attention!"),
				type		: "warning",
				buttons		: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
						return false;
					}
				},
				{
					text	: Loc.g("Valider"), 
					click	: function(){
						
						MyWindow.wait('alertWindow');

						var optionsDlete = {
							action	: "finishPromo",
							promotionid		: id
						};

						MyFacture.post('cataloguepromo', optionsDlete, function (data) {
							Utils.reload();
						}, 'json');

					}
				}
			]
		};

		MyWindow.alert(Loc.g("Vous allez passer au statut <b>terminé</b> la promotion sélectionnée ?"), options);
	},
	
	/**
	 * 
	 * @param {type} id
	 * @returns {undefined}
	 */
	playPromo : function(id){
		
		var options = {
				resizable	: false,
				noclose		: true,
				title		: Loc.g("Attention!"),
				type		: "warning",
				buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
						return false;
					}
				},
				{
					text : Loc.g("Oui"), 
					click : function(){
						
						MyWindow.wait('alertWindow');

						var optionsDlete = {
							action			: "playPromo",
							promotionid		: id
						};

						MyFacture.post('cataloguepromo', optionsDlete, function (data) {
							Utils.reload();
						}, 'json');

					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Voulez-vous reprendre cette promotion ?"), options);		
	},
	
	/**
	 * 
	 * @param {type} ihpid
	 * @param {type} promotionid
	 * @returns {undefined}
	 */
	unlinkItem : function(ihpid, promotionid){
		
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Attention!"),
			type		: "warning",
			buttons		: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
						return false;
					}
				},
				{
					text : Loc.g("Valider"), 
					click : function(){

						MyWindow.wait('alertWindow');

						var optionsDlete = {
							action	: "unlinkItem",
							ihpid	: ihpid,
							promotionid : promotionid
						};

						MyFacture.post('cataloguepromo', optionsDlete, function (data) {
							Utils.reload();
						}, 'json');

					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Le produit va être enlevé de la promotion ?"), options);				
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	MassApplyToAll: function(e){
		
		var input		= $(e).closest('.form-input').find("input, select");
		var mustCheck	= input.closest('.massAdd_check').val() ? input.closest('.massAdd_check').val() : 'Y';
		
		$("#massAddPromotions" +  ' .'+ input.attr('fieldtoapply') ).each(function( index ) {
			
			if(input.hasClass('toApply')) {
				
				if($(this).attr('readonly') === undefined){
				
					if($(this).hasClass('ui-state-error')){
						$(this).focus();
					}

					$(this).val( input.val() );
					$(this).trigger( "change" );
					
				}
				
			} else if(input.hasClass('toCheck')) {
				
				var val = mustCheck=='uncheckAll' ? false : true;
				
				if($(this).attr('data-id') == input.val() || input.val() == 0){
					$(this).prop('checked', val);
				}
				
			}
			
		});
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	MassApplyToAllUseOn : function(e){
		
		var input_useOn		= $(e).closest('.form-input').find("select.massAdd_useOn");
		var input_useOnBool = $(e).closest('.form-input').find("select.massAdd_useOn_bool");
		
		$("#massAddPromotions" +  ' .'+ input_useOn.val() ).each(function( index ) {
				
			if($(this).val() == input_useOnBool.val()){
				$(this).prop('checked', true);
				ItemPromo.onShowLinkeds($(this));
			}
			
		});		
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	onMassUseOnChange : function(e){
		
		var input_useOn		= $(e.currentTarget);
		var elemtarget		= input_useOn.closest('#groupedInfos').find('.massAddEcommerce');
		
		if(input_useOn.val() == 'massAdd_useOnEcommerce'){
			elemtarget.show();
		} else {
			elemtarget.hide();
		}
	},
	
	/**
	 * 
	 * @param {type} input
	 * @returns {undefined}
	 */
	onMassEndDateChange: function(input){
		var check = (input.val() == '') ? true : false;
		input.closest('.col').find('.massAdd_neverExpires').prop('checked', check);
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	MassChangeDiscountUnit: function(e){
		
		var current			= $(e.currentTarget);
		var discountamount	= current.closest('#groupedInfos').find('#massAdd_discountamount');
		
		if(current.val() == 'price'){
			discountamount.val('');
			discountamount.prop('readonly', true);
		} else {
			discountamount.prop('readonly', false);
		}
		
		$('#massAdd_discountamount_prepend').trigger("click");
		
		$(".massAddDiscountUnit").each(function() {
			$(this).val(current.val());
			$(this).trigger("change");
		});
		
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	prepareFilterForm: function(){
		var options = {success:function(data){ItemPromo.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("promotionsFilterForm", "cataloguepromo&action=updateListing", options);
	},
	
	/**
	 * 
	 * @param {type} data
	 * @returns {undefined}
	 */
	processFilterForm: function(data){
		Listing.refresh("promotionsListing", data, data.promotions_metadatas);
		MyFacture.loadPromoQtip();
	},
	
	/**
	 * 
	 * @param {type} rowselection
	 * @returns {undefined}
	 */
	MassdeletePromotions: function(rowselection){
		
		var msg = Loc.g("Vous allez supprimer ces promotions, cette action est irréversible.");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Supprimer les promotions"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Supprimer les promotions"),
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('cataloguepromo', {action: "massDelete", rows : rowselection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);		
	},
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massAddPromotions: function(rowSelection){
		
		var options = {
			title	: Loc.g("Ajout en masse de promotions"),
			width	: 1000,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer les promotions"), 
					click : function(){$("#massAddPromotions").submit();}
				}
			],
			callback	: function(){
				ItemPromo.prepareMassAddingForm();
				ItemPromo.init();
			}
		};
		
		var params = {action:"massAddPromotions", items: rowSelection};
		MyWindow.load("cataloguepromo", params, options);
	},
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massStopPromotions: function (rowSelection){
	
		var msg = Loc.g("Vous allez mettre en pause les promotions sélectionnées ?");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Mettre en pause les promotions"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Valider"),
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('cataloguepromo', {action: "massStop", rows : rowSelection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};
		MyWindow.alert(msg, options);	
	},
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massPlayPromotions: function (rowSelection){
	
		var msg = Loc.g("Vous allez reprendre les promotions sélectionnées ?");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Reprendre les promotions"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Valider"),
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('cataloguepromo', {action: "massPlay", rows : rowSelection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);	
	},	
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massFinishPromotions: function (rowSelection){
	
		var msg = Loc.g("Vous allez passer au statut <b>terminé</b> les promotions sélectionnées ?");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Terminer les promotions"),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Valider"),
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('cataloguepromo', {action: "massFinish", rows : rowSelection}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);	
	},		
	
	/**
	 * 
	 * @param {type} e_input
	 * @param {type} target
	 * @returns {undefined}
	 */
	onShowLinkeds : function(e_input, target){
		
		var tar = target;
		if(target === undefined){
			tar = '.promoLinkedModules';
		}
		
		if(e_input.val() == 'Y'){
			e_input.closest('.promoLinkedRow').find( tar ).show();
		} else {
			e_input.closest('.promoLinkedRow').find( tar ).hide();
		}
		
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	massComputeDiscountAmount: function(e){
		
		var input			= $(e.currentTarget);
		var numberFormat	= NumberFormat.loadFromInputs("numformat_");
		
		if(input.closest('.onePromoToAdd').find('.massAddDiscountUnit').val() == 'percent'){
			input.closest('.col').find('.input-addon').html('%');
		} else {
			input.closest('.col').find('.input-addon').html(numberFormat.currency);
		}
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	onRCUnchecked: function(e){
		
		var input	= $(e.currentTarget);
		var tr		= input.closest('tr');
		
		if(!input.prop('checked')){
			tr.removeClass('enabledPromoRC');
			tr.addClass('disabledPromoRC');
		} else {
			tr.removeClass('disabledPromoRC');
			tr.addClass('enabledPromoRC');
		}
		
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 */
	generateCoupon : function(e){
		$(e.currentTarget).parent().find('.promo_coupon').val(Utils.generateRandom());
	},
	
	/**
	 * 
	 * @param {type} totalAmount
	 * @param {type} thirdId
	 * @param {type} coupon
	 * @param {type} rcId
	 * @param {type} promotion
	 * @returns {undefined}
	 */
	checkCouponForDocForm : function(totalAmount, thirdId, coupon, rcId, promotion, field){
		
		var params = {
			action		: "checkCoupon",
			totalAmount : totalAmount,
			thirdId		: thirdId,
			coupon		: coupon,
			rcId		: rcId
		};
		
		MyFacture.post('cataloguepromo', params, function (data) {
			
			if(data.status == 'success'){
				
				var promotiondetails = data.content;
				
				$(field).attr('e_showdescondoc', promotiondetails.showDescOnDoc);
				
				DocFormv2.setGlobalDiscount(promotion.formatted_discountAmount, promotion.discountunit);
				
				if(promotiondetails.showDescOnDoc == 'Y'){
					
					var lang = promotiondetails.langs[$('#docLang').val()];
					var text = promotiondetails.docdesc;
					
					if(lang){
						text = lang.docdesc.name;
					}
					
					DocFormv2.setNote(text);
					
				}
				
				if(promotiondetails.couponConditions.freeshipping && promotiondetails.couponConditions.freeshipping.value == 'Y'){
					
					$('input[name="isShippingFreeForPromotion"]').val('Y');
					DocFormv2.setShippingRowsAsFreeForPromotion();
						
				} else {
					$('input[name="isShippingFreeForPromotion"]').val('N');
				}
				
				DocFormv2.disableGlobalDiscount(true);		
				
				MyWindow.alert(Loc.g('La promotion a bien été appliquée !'));

			} else {
				
				$('#promo_coupon').tokenInput('clear');
				DocFormv2.setGlobalDiscount(0, 'percent');
				DocFormv2.setNote("", true);
				MyWindow.alert(Loc.g('La promotion ne peut être appliquée'));
				
			}
			
		}, "json");

	},
	
};

window.PromoListing = {
	
	/**
	 * @desc show or hide search part related to catalogue
	 * @param {type} e
	 * @returns {undefined}
	 */
	onTypeChange : function(e) {
		
		var $current = $(e.currentTarget);
		
		if($current.val() == 'coupon'){
			$('.item-filter-group').addClass('hidden');
			$('.category-filter-group').addClass('hidden');
		} else {
			$('.item-filter-group').removeClass('hidden');
			$('.category-filter-group').removeClass('hidden');
		}
		
	}
	
};
